<div class="insurance-create-external">
	<app-page-title [pagetitle]="'Cтрахование путешествующих'"></app-page-title>

	<div>
		<div class="insurance-create-external__frame-wrap">
			<iframe
				class="insurance-create-external__frame"
				[src]="frameSrc"
			></iframe>
		</div>
	</div>
</div>
